import type { CellContext } from '@tanstack/react-table'

export const PercentageCell = <TData, TValue>(
  cell: CellContext<TData, TValue>,
): React.ReactNode => {
  const value = cell.getValue() as number

  if (value === null) {
    return <span className="text-muted-foreground">&mdash;</span>
  }

  return (
    <span
      className={
        value >= 0 ? 'text-emerald-600 font-medium' : 'text-red-600 font-medium'
      }
    >
      {value >= 0 ? '+' : ''}
      {value.toLocaleString('en-US', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })}
      %
    </span>
  )
}
